import {LayoutIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 22"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#i661197543__a)" }, [
      _createElementVNode("path", {
        fill: "currentColor",
        d: "M0 21.5h24L12 .5zm13-2.316h-2.182v-2.21H13zm0-3.684h-2.182v-8H13z"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "i661197543__a" }, [
        _createElementVNode("path", { d: "M0 .5h24v21H0z" })
      ])
    ], -1)
  ]))]))
}
export default { render() { return h(LayoutIcon, {icon: {render}, name: "alert"}) } }